<template>
  <div>
    <v-dialog v-model="localDialog" scrollable max-width="800" persistent lazy>
      <v-card>
        <v-toolbar color="primary" flat dense card dark>
          <v-toolbar-title>
            {{
              $t('action.actions.upload', { field: $t('fields.matches.video') })
            }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 px-2>
              <v-select
                v-model="type"
                v-validate="'required'"
                :items="videoTypes"
                :label="
                  $t('action.actions.select', {
                    field: $t('fields.global.type'),
                  }) + ' (*)'
                "
                :data-vv-name="$t('fields.global.type')"
                :error-messages="errors.collect($t('fields.global.type'))"
              />
            </v-flex>
            <v-flex v-if="type == 'video'" xs12 sm6 px-2>
              <v-text-field
                v-model="video"
                v-validate="{
                  url: { require_protocol: true },
                  required: type == 'video',
                }"
                :label="$t('fields.matches.url') + ' (*)'"
                :data-vv-name="$t('fields.matches.video')"
                :error-messages="errors.collect($t('fields.matches.video'))"
              />
            </v-flex>
            <v-flex v-else-if="type == 'upload'" xs12 px-2>
              <video-uploader
                @submit="submit"
                :objectId="objectId"
                :type-video="typeVideo"
                @upload="onUpload"
                @reload="onReload"
              ></video-uploader>
            </v-flex>
            <v-flex xs12 px-2>
              <v-card flat>
                <v-layout fill-height align-center justify-center ma-0>
                  <iframe
                    v-if="youtubeVideo"
                    :src="youtubeVideo"
                    width="480"
                    height="360"
                    frameborder="0"
                    allowfullscreen
                  />
                  <video
                    v-else-if="video"
                    :src="video"
                    width="480"
                    height="360"
                    controls
                  />
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <template>
            <meta-button type="reset" :disabled="loading" @click="clear" />

            <meta-button type="cancel" @click="cancel" />
            <v-btn
              v-if="type == 'video'"
              small
              :loading="loading"
              color="primary"
              @click="submit()"
            >
              {{ $t('action.buttons.save') }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" max-width="600" persistent>
      <v-card>
        <v-toolbar color="primary" flat dense card dark>
          <v-toolbar-title>
            {{ $t('titles.global.confirmation') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <span class="subheading">{{ confirmVideoMessage }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small color="primary" @click="dialogConfirm = false">
            {{ $t('action.buttons.confirm') }}
          </v-btn>
          <meta-button type="cancel" @click="cancel" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VideoUploader from '@/components/widgets/Input/VideoUploader'

export default {
  name: 'DialogUploadVideo',
  components: {
    VideoUploader,
  },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    objectId: {
      type: String,
      required: false,
      default: '',
    },
    videoExist: {
      type: Object,
      required: false,
      default: null,
    },
    typeVideo: {
      type: String,
      required: false,
      default: 'match',
    },
  },
  data() {
    return {
      type: '',
      video: '',
      videoTypes: [
        {
          text: 'Video',
          value: 'video',
        },
        {
          text: this.$t('action.actions.upload', {
            field: this.$t('fields.matches.video'),
          }),
          value: 'upload',
        },
      ],

      dialogConfirm: false,
    }
  },
  watch: {
    type() {
      this.file = ''
      this.titleFile = ''
      this.video = ''
    },
    localDialog(val, oldVal) {
      if (!val && oldVal) this.cancel()
      else if (val && !oldVal && this.videoExist) {
        this.$nextTick(() => {
          this.dialogConfirm = true
        })
      }
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.files.loading,
    }),
    localDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    youtubeVideo() {
      if (!this.video) return ''
      const url = 'https://www.youtube.com/embed/'
      let temp
      if (this.video.includes('youtube') && this.video.split('?v=').length) {
        temp = this.video.split('?v=')[1]
      } else if (this.video.includes('youtu.be')) {
        let videoId = this.video.split('youtu.be/')
        if (videoId.length && videoId[1]) temp = videoId[1]
      }

      if (temp) return url + temp
      else return ''
    },
    confirmVideoMessage() {
      if (this.typeVideo == 'training')
        return this.$t('titles.matches.confirmTrainingVideo')
      // if (this.typeVideo == 'match')
      else return this.$t('titles.matches.confirmMatchVideo')
    },
  },
  methods: {
    ...mapActions({
      uploadFile: 'files/uploadFile',
      createFile: 'files/create',
      deleteFile: 'files/delete',
    }),
    submit() {
      this.validate().then(async (valid) => {
        if (!valid) return
        if (this.type === 'video') {
          this._createFile()
        } else if (this.type === 'upload') {
          if (this.videoExist) {
            this.deleteFile(this.videoExist._id).then(() => {
              this.$emit('upload')
            })
          } else {
            this.$emit('upload')
          }
          this.cancel()
        }
      })
    },
    _createFile() {
      let payload = {
        size: '0',
        type: this.typeVideo,
        path: this.video,
        objectId: this.objectId,
      }

      this.createFile(payload).then(() => {
        if (this.videoExist) {
          this.deleteFile(this.videoExist._id)
        }
        this.$emit('upload')
        this.cancel()
      })
    },
    fileChanged(file) {
      this.video = ''
      if (file.size < 1) return
      this.file = file
      this.titleFile = file.name
      const reader = new FileReader()
      const vm = this
      if (file.size < 209715200) {
        reader.onload = (e) => {
          vm.video = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    clear() {
      this.$validator.pause()
      this.nextTick(() => {
        this.file = ''
        this.titleFile = ''
        this.video = ''
        this.type = ''
        this.dialogConfirm = false
        this.$validator.reset()
        this.$validator.resume()
      })
    },
    cancel() {
      this.$emit('input', false)
      this.clear()
    },
    onReload() {
      this.$emit('upload')
    },
    onUpload() {
      this.$emit('upload')
      this.cancel()
    },
  },
}
</script>
